"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import SSRIcon from "@ingka/ssr-icon";
import cx from "classnames";
const inverseTypes = "secondary";
const DualButton = (props) => {
  const {
    type = "secondary",
    small,
    prefix = "",
    className,
    orientation = "horizontal",
    firstText,
    secondText,
    groupLabel,
    flipIconRTL = false,
    ssrIconFirst,
    ssrIconSecond,
    inverseTheme = false,
    onClickFirst,
    onClickSecond,
    disabledFirst = false,
    disabledSecond = false,
    ...other
  } = props;
  const classes = cx(
    `${prefix}dual-btn`,
    type && `${prefix}dual-btn--${type}`,
    `${prefix}dual-btn--${orientation}`,
    small && `${prefix}dual-btn--small`,
    inverseTheme && type === inverseTypes && `${prefix}dual-btn--inverse`,
    flipIconRTL && `${prefix}dual-btn--flip-rtl`,
    className && className
  );
  const inverseClass = cx(
    inverseTheme && type === inverseTypes && ` ${prefix}dual-btn--inverse`
  );
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classes,
      role: groupLabel && "group",
      "aria-label": groupLabel,
      ...other,
      children: [
        /* @__PURE__ */ jsxs(
          "button",
          {
            className: `${prefix}dual-btn__first${inverseClass}`,
            onClick: onClickFirst,
            disabled: disabledFirst,
            children: [
              /* @__PURE__ */ jsx(
                SSRIcon,
                {
                  prefix,
                  className: `${prefix}dual-btn__icon`,
                  paths: ssrIconFirst
                }
              ),
              firstText && /* @__PURE__ */ jsx("span", { className: `${prefix}dual-btn__label`, children: firstText })
            ]
          }
        ),
        /* @__PURE__ */ jsx("span", { className: `${prefix}dual-btn__divider` }),
        /* @__PURE__ */ jsxs(
          "button",
          {
            className: `${prefix}dual-btn__second${inverseClass}`,
            onClick: onClickSecond,
            disabled: disabledSecond,
            children: [
              /* @__PURE__ */ jsx(
                SSRIcon,
                {
                  prefix,
                  className: `${prefix}dual-btn__icon`,
                  paths: ssrIconSecond
                }
              ),
              secondText && /* @__PURE__ */ jsx("span", { className: `${prefix}dual-btn__label`, children: secondText })
            ]
          }
        )
      ]
    }
  );
};
var DualButton_default = DualButton;
export {
  DualButton_default as default
};
